import {Component, Inject, OnInit} from '@angular/core';
import {SharedService} from '../../../../services/shared-service/shared.service';
import {UserService} from '../../../../services/users-service/user-service';
import {ErrorService} from '../../../../util/error_service/error.service';
import {ToastService} from "../../../../util/toast-service/toast.service";
import {MD_DIALOG_DATA, MdCheckbox, MdDialog, MdDialogRef, MdSnackBar} from '@angular/material';

@Component({
  selector: 'app-airtime',
  templateUrl: './airtime.component.html',
  styleUrls: ['./airtime.component.scss']
})
export class AirtimeComponent implements OnInit {
  setId: any;

  errorResponse: any;
  pageTitle = 'Airtime Transactions';
  public adminsTotal: number;
  public admins : any;
  public airtimeTransactions : any;
  public isTransactionsLoaded : boolean;
  public transactionsWithId : any;
  public range: any;
  public useRange: boolean;
  public rangeFromValue: number;
  public fromDate: Date;
  public toDate: Date;
  public rangeToValue: number;
  public arg: any;
  public recentTransaction = [];
  public searchText = '';

  public checkboxArgs : any;

  public isSuccessTicked : boolean;
  public isPendingTicked : boolean;
  public isFailedTicked : boolean;

  public dashboardData : any = {
    'failedTrans': 0,
    'pendingTrans': 0,
    'successfulTran': 0,
    'transactionCount': 0
  }

  constructor(public _sharedService: SharedService, public toast: ToastService, public dialog: MdDialog,
              public adminService: UserService, public error: ErrorService) {
    this._sharedService.emitChange(this.pageTitle);
    this.adminsTotal = 0;
    this.range = 'today'; // default range is today
    this.isTransactionsLoaded = true;
    this.transactionsWithId = [];
    this.checkboxArgs = [];
    this.isSuccessTicked = true;
    this.isPendingTicked = true;
    this.isFailedTicked = true;
    this.getRange();
    this.getAirtimeStatistics();
    this.getAirtimeTransactions();

  }

  getTranxData(id : any){
    this.setId = id;
  }

  retryTransaction = () => {
    this.adminService.retryTransaction(this.setId).subscribe(
      response => {
        // console.log('retry was successful');
        this.getAirtimeTransactions(true);
        this.toast.showSuccess('Transaction was completed successfully', 'Success');
        // this.isTransactionsLoaded = false;
      },
      err => {
        // console.log(err);
        this.errorResponse = this.error.errorHandlerWithText(this.retryTransaction, err);
        this.toast.showError(this.errorResponse.message, 'Error');
        // console.log(this.errorResponse);
        // this.isTransactionsLoaded = false;
      }
    )
  }

  refundTransaction = () => {
    this.adminService.refundTransaction(this.setId).subscribe(
      response => {
        // console.log('reversed successfully');
        this.getAirtimeTransactions(true);
        this.toast.showSuccess('Transaction was reversed successfully', 'Success');
        // this.isTransactionsLoaded = false;
      },
      err => {
        // console.log(err);
        this.errorResponse = this.error.errorHandlerWithText(this.refundTransaction, err);
        this.toast.showError(this.errorResponse.message, 'Error');
        // console.log(this.errorResponse);
        // this.isTransactionsLoaded = false;
      }
    )
  }

  updateToSuccess = () => {
    this.adminService.updateTransactionToSuccess(this.setId).subscribe(
      response => {
        // console.log('updated to success successfully');
        this.getAirtimeTransactions(true);
        this.toast.showSuccess('Transaction was updated successfully', 'Success');

        // this.isTransactionsLoaded = false;
      },
      err => {
        // console.log(err);
        this.errorResponse = this.error.errorHandlerWithText(this.updateToSuccess, err);
        this.toast.showError(this.errorResponse.message, 'Error');
        // console.log(this.errorResponse);
        // this.isTransactionsLoaded = false;
      }
    )
  }

  // Re-Sort data ////////////////////
  getTransactionsWithId = () => {
    this.transactionsWithId = [];
    for (let i = 0; i < this.airtimeTransactions.length; i++ ) {
      const sortedTranx: any = {id: 0, data: {}};
      sortedTranx.id = i + 1;
      sortedTranx.data = this.airtimeTransactions[i];
      this.transactionsWithId.push(sortedTranx);
      this.isTransactionsLoaded = false;
    }
    // console.log('************ trax with id ****************');
    // console.log(this.transactionsWithId);
  }

  // populate transactions statistics
  getAirtimeStatistics = () => {
    this.adminService.getStatistics().subscribe(
      response => {
        const statisticsData = response.data[0];
        // console.log(statisticsData);
        this.dashboardData.transactionCount = statisticsData.todayAirtimeTransactions;
        this.dashboardData.successfulTran = statisticsData.todaySuccessfulAirtimeTransactions;
        this.dashboardData.pendingTrans = statisticsData.todayPendingAirtimeTransactions;
        this.dashboardData.failedTrans = statisticsData.todayFailedAirtimeTransactions;
      },
      err => {
        // console.log(err);
        this.errorResponse = this.error.errorHandlerWithText(this.getAirtimeStatistics, err);
        // console.log(this.errorResponse);

      }
    )
  }

  // get all airtime transactions or by range
  getAirtimeTransactions = (isloading : boolean = true) => {
    if(isloading){
      this.isTransactionsLoaded = true;
    }
    else{
      this.isTransactionsLoaded = false;
    }
    this.airtimeTransactions = [];
    this.isTransactionsLoaded = true;
    this.adminService.getAirtimeTransactions(this.arg).subscribe(
      response => {
        this.airtimeTransactions = response.data;
        // console.log('***** Airtime Transactions ****');
        // console.log(this.airtimeTransactions);
        this.getTransactionsWithId();
        // console.log('***** Airtime Transactions with id ****');
        // console.log(this.transactionsWithId);
        this.isTransactionsLoaded = false;
      },
      err => {
        // console.log(err);
        this.errorResponse = this.error.errorHandlerWithText(this.getAirtimeStatistics, err);
        // console.log(this.errorResponse);
        this.isTransactionsLoaded = false;

      }
    )
  }

  // get transactions by range
  getRangeTransaction = () => {
    this.rangeFromValue = new Date(this.fromDate).getTime();
    this.rangeToValue = new Date(this.toDate).getTime();
    this.arg = 'range?startDateTimestamp=' + this.rangeFromValue + '&' + 'endDateTimestamp=' + this.rangeToValue;
    this.recentTransaction = [];
    this.getAirtimeTransactions(true);
  }

  getRange = () => {
    if ( this.range !== 'other') {
      this.useRange = false;
      this.arg = this.range;
      this.recentTransaction = [];
      this.getAirtimeTransactions();
    } else {
      this.useRange = true;
    }
  }


  ngOnInit() {
    this.getAirtimeStatistics();
    this.getAirtimeTransactions();

  }

  downloadDialog() {
    const dialogRef = this.dialog.open(ReportDialogComponent,{
      height: '450px',
      width: '400px',
      data: {
        id : '3'
      }
    });

    dialogRef.afterClosed().subscribe(result => {

      // console.log('********', result);
      if( result == 'close'){
        return false;
      }
      else if( result == 'success'){
        const message = 'Report download was successful' ;
        this.toast.showSuccess(message, 'Download');
      }
      else if( result == 'failed'){
        const message = 'Report download failed' ;
        this.toast.showError(message, 'Download');
      }
    });
  }

}


@Component({
  selector: 'download-dialog',
  styles: [ '.user-details { margin-bottom: 5px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: center;}',
    '.user-details span{ color:#444; text-transform:uppercase; text-overflow:ellipsis}',
    '.wallet { font-weight: normal; padding:2px 5px; border-radius:5px;text-align: center;} background-color:#ededed; display: inline-block;} '],
  templateUrl: 'report-dialog.html',
})
export class ReportDialogComponent {
  isDownloading: boolean;
  download: number;
  isPendingTicked: boolean;
  isFailedTicked: boolean;
  isSuccessTicked: boolean;
  errorResponse: any;
  rangeToValue: number;
  fromDate: any;
  rangeFromValue: number;
  useRange: boolean;
  systemCommission: any;
  networkName: any;
  agentCommission: any;
  networkId: any;
  range : any;


  public amount : number;
  public isUpdating : boolean;
  public toDate: any;
  public arg: string;


  constructor(
    public dialogRef: MdDialogRef<ReportDialogComponent>, private agentService: UserService, private error: ErrorService,
    @Inject(MD_DIALOG_DATA) private data: any, private adminService: UserService,) {
    this.networkId = this.data.id;
    this.range = 'today';
    this.isSuccessTicked = true;
    this.isFailedTicked = true;
    this.isPendingTicked = true;
    this.download = 1;
    this.isDownloading = false;
    this.getRange();
  }

  getRange = () => {
    if ( this.range !== 'other') {
      this.useRange = false;
      this.arg = this.range+ '?';
    } else {
      this.useRange = true;
    }
  }

  getRangeTransaction = () => {  // transactions/today?download=1&downloadSuccessful=1&downloadFailed=1&downloadPending=1
    this.rangeFromValue = new Date(this.fromDate).getTime();
    this.rangeToValue = new Date(this.toDate).getTime();
    this.arg = 'range?startDateTimestamp=' + this.rangeFromValue + '&' + 'endDateTimestamp=' + this.rangeToValue + '&';
    // console.log('********* using range transaction', this.arg);
    // this.downloadReport();
    //
  }

  // get all airtime transactions or by range
  downloadReport = () => {
    if(this.useRange){
      this.getRangeTransaction();
    }

    this.isDownloading = true;
    this.adminService.getAirtimeTransactions(this.arg, this.download, this.isSuccessTicked ? 1:0, this.isFailedTicked ? 1:0, this.isPendingTicked ? 1:0).subscribe(
      response => {

        // IE doesn't allow using a blob object directly as link href
        // instead it is necessary to use msSaveOrOpenBlob
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(response.blob());
          return;
        }

        const link = document.createElement("a");
        const data = window.URL.createObjectURL(response.blob());
        link.href = URL.createObjectURL(response.blob());
        // start download
        link.download= "airtime-report.csv";
        link.click();
        this.isDownloading = false;
        this.dialogRef.close('success');
        setTimeout(function(){
            // For Firefox it is necessary to delay revoking the ObjectURL
          window.URL.revokeObjectURL(data);}
        , 100)
      },
      err => {
        // // console.log(err);
        this.error.errorHandlerWithText(this.downloadReport, err);
        //this.dialogRef.close('failed');
        //this.isDownloading = false;

        // // console.log(this.errorResponse);
      }
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/Dashboard/DashboardPages/Transactions/airtime/airtime.component.ts